module.exports = __webpack_public_path__ + "media/images/arrows/down-cyan-4f2ef5c23abcb22433ed5a94e07e0ad9.svg";